import type { StructuredCollectionConfig } from '@ltvco/refresh-lib/hooks';

/**
 * Collections used by the Birth Index Records.
 *
 * IMPORTANT:
 * - The order of this list must match the order defined in Remoulade.
 * - Do not reorder existing collections, as the position is used to maintain
 *   consistency with Remoulade mappings and processing logic.
 * - When adding a new collection, append it to the end of the array.
 * - Existing entries should remain in their current positions.
 */
export const BIRTH_INDEX_COLLECTIONS: StructuredCollectionConfig[] = [
  {
    id: '0000030',
    plainName: 'Nebraska Birth Index, 1912-1989',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'ne_birth_index',
    state: 'NE',
    yearStart: 1912,
    yearEnd: 1989,
    options: { combineFirstMiddleName: true },
  },
  {
    id: '0000052',
    plainName: 'Connecticut Birth Index, 1897-1917',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'ct_birth_index',
    state: 'CT',
    yearStart: 1897,
    yearEnd: 1917,
    options: { combineFirstMiddleName: true },
  },
  {
    id: '0000036',
    plainName: 'Kentucky Birth Index, 1911-1989',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'ky_birth_index',
    state: 'KY',
    yearStart: 1911,
    yearEnd: 1989,
  },
  {
    id: '0000069',
    plainName: 'Texas Birth Index, 1926-1948',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'tx_birth_index',
    state: 'TX',
    yearStart: 1926,
    yearEnd: 1948,
  },
  {
    id: '0000082',
    plainName: 'Minnesota Birth Index, 1900-1934',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'mn_birth_index',
    state: 'MN',
    yearStart: 1900,
    yearEnd: 1934,
  },
  {
    id: '0000022',
    plainName: 'Massachusetts Birth Index, 1841-1910',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'ma_birth_index',
    state: 'MA',
    yearStart: 1841,
    yearEnd: 1910,
    options: { combineFirstMiddleName: true },
    isV2: true,
  },
  {
    id: '0000070',
    plainName: 'Texas, Birth Index, 1948-2007',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'tx_birth_index',
    state: 'TX',
    yearStart: 1948,
    yearEnd: 2007,
    isV2: true,
  },
  {
    id: '0000009',
    plainName: 'Ohio, Birth Index, 1908-2007',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'oh_birth_index',
    state: 'OH',
    yearStart: 1908,
    yearEnd: 2007,
    isV2: true,
  },
  {
    id: '0000047',
    plainName: 'Missouri, Birth Index, 1910-2007',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'mo_birth_index',
    state: 'MO',
    yearStart: 1910,
    yearEnd: 2007,
    isV2: true,
  },
  {
    id: '0000005',
    plainName: 'United States, California, Birth Index, 1905-1995',
    type: 'birth_index',
    source: 'birthIndexSearch',
    reportType: 'birth_indexes',
    ga4ReportType: 'ca_birth_index',
    state: 'CA',
    yearStart: 1905,
    yearEnd: 1995,
    isV2: true,
  },
];
